import { Component, OnDestroy, OnInit } from '@angular/core';
import { RootState } from '@next/core-lib/app';
import { AuthorizationSelectors } from '@next/core-lib/authorization';
import { LocaleService } from '@next/core-lib/i18n';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';

import { ReferenceScheme } from '../../../reference-scheme/models/reference-scheme.model';
import { FeedAdvice } from '../../models/feed-advice.model';
import * as feedAdviceActions from '../../store/feed-advice.actions';
import { getReferenceSchemes } from '../../store/feed-advice.selectors';

@Component({
  selector: 'app-create-feed-advice-from-reference',
  templateUrl: './create-feed-advice-from-reference.component.html',
  styleUrls: ['./create-feed-advice-from-reference.component.scss'],
  standalone: false,
})
export class CreateFeedAdviceFromReferenceComponent implements OnInit, OnDestroy {
  /* SELECTORS & DATA */
  referenceSchemes$: Observable<ReferenceScheme[]> = this.store.select(getReferenceSchemes);

  /* INDICATORS */
  isAdvisor = false;

  /* SUBSCRIPTIONS */
  subAuthorization: Subscription;

  ltr$ = this.locale.ltr$;

  constructor(
    private readonly store: Store<RootState>,
    private readonly locale: LocaleService,
  ) {
    this.subAuthorization = this.store
      .pipe(select(AuthorizationSelectors.hasAtLeastAdvisorRole))
      .subscribe((hasAtLeastAdvisorRole) => {
        this.isAdvisor = hasAtLeastAdvisorRole;
      });
  }
  ngOnDestroy(): void {
    if (this.subAuthorization) {
      this.subAuthorization.unsubscribe();
    }
  }

  ngOnInit(): void {
    this.store.dispatch(feedAdviceActions.loadReferenceSchemesByCountryRequest());
    this.store.dispatch(feedAdviceActions.setBaseFeedAdviceRequest({ feedAdvice: null }));
  }

  fromScratchCreate() {
    if (this.isAdvisor) {
      this.store.dispatch(feedAdviceActions.createAdviceNavigation());
    }
  }

  createFeedAdviceFromReference(referenceScheme: ReferenceScheme) {
    if (this.isAdvisor) {
      const base = referenceScheme as FeedAdvice;
      this.store.dispatch(feedAdviceActions.setBaseFeedAdviceRequest({ feedAdvice: base }));
      this.store.dispatch(feedAdviceActions.createAdviceNavigation());
    }
  }
}
